/**
 * Como o laboratório combina receber.
 *
 * Lista fechada com um complemento livre ao lado, e não texto livre puro: sem
 * isso "PIX", "Pix", "pix " e "transferência" viram quatro formas diferentes
 * no relatório — o mesmo problema que `bull_name` tem em quatro tabelas.
 *
 * `pedeComplemento` marca a única em que o complemento é o dado: "outro" sem
 * explicação não informa nada. Nas demais o campo continua aparecendo, porque
 * número de cheque e bandeira de cartão são exatamente o que se procura
 * depois — só não é obrigatório.
 */
export const FORMAS_DE_PAGAMENTO = [
  { id: 'pix',      label: 'Pix',      dica: 'Chave ou identificador' },
  { id: 'cartao',   label: 'Cartão',   dica: 'Bandeira, parcelas na maquininha' },
  { id: 'boleto',   label: 'Boleto',   dica: 'Nosso número, banco emissor' },
  { id: 'cheque',   label: 'Cheque',   dica: 'Número e banco' },
  { id: 'dinheiro', label: 'Dinheiro', dica: 'Quem recebeu' },
  { id: 'outro',    label: 'Outro',    dica: 'Descreva a forma', pedeComplemento: true },
];

export const FORMA_POR_ID = Object.fromEntries(FORMAS_DE_PAGAMENTO.map(f => [f.id, f]));

/**
 * Forma desconhecida volta como o próprio id em vez de sumir.
 *
 * Mesma decisão de `rotuloDoServico`: mostrar o id cru é feio, mostrar vazio
 * esconderia que a forma foi informada.
 */
export const rotuloDaForma = (id) => (id ? (FORMA_POR_ID[id]?.label || id) : '');

/** Como a forma aparece numa linha: "Cheque · 4412 Bradesco". */
export const formaPorExtenso = (id, obs) => {
  const base = rotuloDaForma(id);
  if (!base) return '';
  const extra = (obs || '').trim();
  return extra ? `${base} · ${extra}` : base;
};

/**
 * A forma escolhida está completa o bastante para gravar?
 *
 * Só "outro" exige complemento. Deixar gravar "Outro" sozinho produziria uma
 * fatura que não diz como foi paga — pior que não ter escolhido forma nenhuma,
 * porque aparenta estar preenchida.
 */
export const formaIncompleta = (id, obs) =>
  FORMA_POR_ID[id]?.pedeComplemento === true && !(obs || '').trim();
